
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponet";
import { BackGround } from "./BackGround";

export class BackGroundComponent extends AbstractDisplayComponent {
    private backGround: BackGround;

    public override init() {
        let config = {
            labelName: "backGroundComponent",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 0,
                posY: 0,
                scale: 1,
            },
            portrait: {
                posX: 0,
                posY: 0,
                scale: 1,
            }
        };

        super.init();
        this.backGround = new BackGround(config);
    }


    public getInstance(): BackGround {

        return this.backGround;

    }


    public override destroy(): void {

        this.backGround.destroy({ children: true });

    }


}

